var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.597,
    height: 45.537,
    viewBox: "0 0 50.597 45.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7227",
    "data-name": "Group 7227",
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6846",
    "data-name": "Path 6846",
    d: "M39.4,17.778l1.966-1.966a.843.843,0,0,0,0-1.192l-3.373-3.373a.843.843,0,0,0-1.192,0l-6.5,6.5H20.53A2.533,2.533,0,0,0,18,20.276v6.746a2.533,2.533,0,0,0,2.53,2.53H39.082a2.533,2.533,0,0,0,2.53-2.53V20.276A2.525,2.525,0,0,0,39.4,17.778Zm-2-4.743,2.181,2.181-1.337,1.337-2.181-2.181Zm2.53,13.987a.844.844,0,0,1-.843.843H20.53a.844.844,0,0,1-.843-.843V20.276a.844.844,0,0,1,.843-.843h8.084L26.68,21.366a.843.843,0,0,0-.247.6v3.373a.843.843,0,0,0,.843.843h3.373a.843.843,0,0,0,.6-.247l6.5-6.5h1.337a.844.844,0,0,1,.843.843Z",
    transform: "translate(-2.508 -0.94)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6847",
    "data-name": "Path 6847",
    d: "M50.067,5H4.53A2.533,2.533,0,0,0,2,7.53V39.574A2.533,2.533,0,0,0,4.53,42.1h14.8l-1.5,3.373H36.762l-1.5-3.373h14.8a2.533,2.533,0,0,0,2.53-2.53V7.53A2.533,2.533,0,0,0,50.067,5ZM28.142,38.309a.422.422,0,0,1-.422.422h-.843a.422.422,0,0,1-.422-.422v-.843a.422.422,0,0,1,.422-.422h.843a.422.422,0,0,1,.422.422ZM50.91,33.671H3.687V7.53a.844.844,0,0,1,.843-.843H50.067a.844.844,0,0,1,.843.843ZM39.1,50.537H15.492a1.687,1.687,0,0,1-1.687-1.687h0a1.687,1.687,0,0,1,1.687-1.687H39.1a1.687,1.687,0,0,1,1.687,1.687h0A1.687,1.687,0,0,1,39.1,50.537Z",
    transform: "translate(0 0)",
    fill: "#3d4977"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIcon);
export default __webpack_public_path__ + "static/media/SystemIcon.3d83a2d38882737e23a38ba177d8d69f.svg";
export { ForwardRef as ReactComponent };